import React from 'react';
import SEO from '../components/SEO';
import '../styles/Services.css';

const services = [
  {
    title: 'Web & Software Development',
    description: 'Build a dependable digital foundation with websites, web applications, and custom systems shaped around your business goals.',
    capabilities: ['Business websites', 'React and web applications', 'Custom software and business systems'],
  },
  {
    title: 'E-commerce Development',
    description: 'Create an online buying experience that supports your operations, serves your customers, and is ready to evolve with your business.',
    capabilities: ['Online stores', 'E-commerce customization', 'E-commerce integrations and functionality'],
  },
  {
    title: 'Shopify Development',
    description: 'Develop and extend Shopify storefronts with tailored themes, applications, and integrations aligned with how your business sells.',
    capabilities: ['Shopify store development', 'Shopify theme development and customization', 'Custom Shopify app development', 'Shopify integrations'],
  },
  {
    title: 'API & Payment Integrations',
    description: 'Connect the platforms and services your business relies on through carefully planned APIs and secure integration workflows.',
    capabilities: ['Third-party API integrations', 'Payment gateway integrations', 'Custom integration development'],
  },
  {
    title: 'AI & Business Automation',
    description: 'Reduce repetitive work and improve responsiveness with practical automation designed around your team and customer journey.',
    capabilities: ['AI assistants', 'Customer inquiry automation', 'Follow-ups and lead workflows', 'Booking and appointment automation', 'Repetitive business workflow automation'],
    solutionPath: '/solutions/ai-voice-automation',
  },
];

const Services = () => {
  return (
    <main className="services">
      <SEO
        title="Software Development & Digital Services | Bularis Tech"
        description="Explore Bularis Tech services for web and software development, e-commerce, Shopify, API and payment integrations, and business automation."
        path="/services"
      />
      <header className="services-header">
        <span className="services-eyebrow">What we do</span>
        <h1>Technology Services Built Around Your Business</h1>
        <p>From digital products and online commerce to connected systems and automation, Bularis Tech helps turn business requirements into practical technology.</p>
      </header>

      <section className="services-list" aria-label="Bularis Tech services">
        {services.map((service) => (
          <article className="service-card" key={service.title}>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <ul>
              {service.capabilities.map((capability) => (
                <li key={capability}>{capability}</li>
              ))}
            </ul>
            {service.solutionPath && <a className="service-solution-link" href={service.solutionPath}>Explore AI voice automation <span aria-hidden="true">→</span></a>}
          </article>
        ))}
      </section>
    </main>
  );
};

export default Services;
